import { combineReducers } from "redux";
import QuoteOverviewReducer from "./reducer/QuoteOverview";
export default combineReducers({ QuoteOverviewReducer });
